import { allValues, Rights } from '../rights';

export const ADMINISTRATION_RIGHTS = Object.freeze([
  Rights.RESIDENTS.READ.key,
  Rights.RESIDENTS.WRITE.key,
  ...allValues(Rights.LISTS),
  ...allValues(Rights.RESIDENTS.GENERAL),
  ...allValues(Rights.RESIDENTS.CONTRACT),
  ...allValues(Rights.RESIDENTS.CHECKLIST),
  ...allValues(Rights.RESIDENTS.CONTACTS),
  ...allValues(Rights.RESIDENTS.CONSULTATION),
  ...allValues(Rights.RESIDENTS.UTILS),
  ...allValues(Rights.RESIDENTS.PASTORAL_CARE),
  ...allValues(Rights.RESIDENTS.DOCUMENT_MANAGEMENT),
  Rights.RESIDENTS.FILES.READ.key,
  Rights.RESIDENTS.FILES.WRITE.key,
  Rights.EMPLOYEES.READ.key,
  Rights.EMPLOYEES.WRITE.key,
  ...allValues(Rights.EMPLOYEES.GENERAL),
  ...allValues(Rights.EMPLOYEES.CONTRACT),
  ...allValues(Rights.EMPLOYEES.SYSTEM_ACCESS),
  ...allValues(Rights.EMPLOYEES.CHECKLIST),
  ...allValues(Rights.EMPLOYEES.FILES),
  ...allValues(Rights.BASE_DATA),
  Rights.CARE.READ.key,
  Rights.CARE.WRITE.key,
  Rights.CARE.ABSENCE.key,
  Rights.CARE.ASSESSMENT.READ.key,
  Rights.CARE.CONSULTATION_FORM.READ.key,
  Rights.CARE.MOVEMENT_STATUS.READ.key,
  ...allValues(Rights.CARE.BIOGRAPHY),
  Rights.CARE.DATA_COLLECTION.READ.key,
  Rights.CARE.DECUBITUS_RISK.READ.key,
  Rights.CARE.NUTRITION_PROTOCOL.READ.key,
  Rights.CARE.CASE_DISCUSSION.READ.key,
  Rights.CARE.INDICATORS.READ.key,
  Rights.CARE.MEDICATION_ORDER.READ.key,
  Rights.CARE.MEDICATION.READ.key,
  ...allValues(Rights.CARE.NURSING_REPORT),
  Rights.CARE.REPORT.READ.key,
  Rights.CARE.CARE_PLAN.READ.key,
  Rights.CARE.NURSE_VISIT.READ.key,
  Rights.CARE.CARE_ROUNDS.READ.key,
  Rights.CARE.PAIN_PROTOCOL.READ.key,
  Rights.CARE.SOCIAL_CARE.READ.key,
  ...allValues(Rights.CARE.FALL_PROTOCOL),
  Rights.CARE.FALL_RISK.READ.key,
  Rights.CARE.VITAL_INFORMATIONS.READ.key,
  Rights.CARE.DOCTORS_DIAGNOSIS.READ.key,
  Rights.CARE.VISIT_SHEET.READ.key,
  Rights.CARE.VITAL_SIGNS.READ.key,
  Rights.CARE.WOUND_DOCUMENTATION.READ.key,
  ...allValues(Rights.CARE.EXECUTION),
  ...allValues(Rights.CARE.TASKS),
  ...allValues(Rights.CARE.TASKS_EXTENDED),
  ...allValues(Rights.ADMINISTRATION_AND_INVOICING.PAYER),
  ...allValues(Rights.ADMINISTRATION_AND_INVOICING.INVOICE),
  Rights.GENERAL.CASH_AMOUNT.READ.key,
  Rights.GENERAL.CASH_AMOUNT.WRITE.key,
  Rights.GENERAL.CALENDAR.READ.key,
  Rights.GENERAL.CALENDAR.WRITE.key,
  ...allValues(Rights.GENERAL.CONTACTS),
  ...allValues(Rights.GENERAL.MESSAGES),
  Rights.ROSTER.PRINT.key,
  Rights.ROSTER.ACCESS.LIMITED_READ.key,
  Rights.ROSTER.WEEK_PLAN.key,
  Rights.ROSTER.VACATION_SCHEDULE.READ.key,
]);
